/** @jsx jsx */
import React, { memo } from 'react';
import { css, jsx } from '@compiled/react';

export type Props = { text: string };

export const TextCell = memo<Props>(({ text }: Props) => <div css={textCellStyles}>{text}</div>);

const textCellStyles = css({
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	width: '100%',
});
